import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ 
  title = 'XL Bútor - Egyedi bútor gyártás Kisvárdán 1989 óta',
  description = 'Egyedi bútor tervezés és gyártás saját műhelyben Kisvárdán. 3D tervezés, konyhabútor, szekrények, nappali bútorok. 35+ év tapasztalat, ingyenes felmérés és konzultáció!',
  keywords = 'egyedi bútor, bútor gyártás, Kisvárda, konyhabútor, szekrény, gardrób, nappali bútor, hálószoba bútor, előszoba bútor, egyedi méret, bútorkészítés, asztalos',
  url = 'https://xlbutorbolt.hu',
  image = 'https://xlbutorbolt.hu/images/Weboldalképei/xl-butor-logo.png',
  type = 'website',
  canonical,
}) {
  // Structured Data for Local Business
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'FurnitureStore',
    name: 'XL Bútor',
    alternateName: 'XL Bútorbolt',
    description: 'Egyedi bútor tervezés és gyártás saját műhelyben 1989 óta. Konyhabútor, szekrények, nappali bútorok egyedi méretben.',
    url: 'https://xlbutorbolt.hu',
    logo: 'https://xlbutorbolt.hu/images/Weboldalképei/xl-butor-logo.png',
    image: 'https://xlbutorbolt.hu/images/Weboldalképei/xl-butor-logo.png',
    telephone: '+36704179210',
    email: 'xlbutorbolt@gmail.com',
    foundingDate: '1989',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Attila u. 61',
      addressLocality: 'Kisvárda',
      postalCode: '4600',
      addressCountry: 'HU',
      addressRegion: 'Szabolcs-Szatmár-Bereg'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 48.2157,
      longitude: 22.0778,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '17:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '08:00',
        closes: '13:00',
      },
    ],
    priceRange: '$$',
    paymentAccepted: 'Cash, Credit Card, Bank Transfer',
    currenciesAccepted: 'HUF',
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: 48.2157,
        longitude: 22.0778,
      },
      geoRadius: '100000'
    },
    sameAs: [
      'https://www.facebook.com/goncz.sandor.7'
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Egyedi bútorok',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Konyhabútor készítés',
            description: 'Egyedi méretű konyhabútorok tervezése és gyártása'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Szekrény és gardróbszekrény',
            description: 'Beépített szekrények, gardróbok egyedi méretben'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Nappali bútor',
            description: 'TV állványok, polcrendszerek, dohányzóasztalok'
          }
        }
      ]
    }
  };

  // Organization Schema
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'XL Bútor',
    url: 'https://xlbutorbolt.hu',
    logo: 'https://xlbutorbolt.hu/images/Weboldalképei/xl-butor-logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+36704179210',
      contactType: 'customer service',
      availableLanguage: 'Hungarian'
    },
    sameAs: [
      'https://www.facebook.com/goncz.sandor.7'
    ]
  };

  // BreadcrumbList Schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Főoldal',
        item: 'https://xlbutorbolt.hu'
      }
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang="hu" />
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="XL Bútor" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical || url} />
      
      {/* Language and Region */}
      <meta name="language" content="Hungarian" />
      <meta name="geo.region" content="HU-SZ" />
      <meta name="geo.placename" content="Kisvárda" />
      <meta name="geo.position" content="48.2157;22.0778" />
      <meta name="ICBM" content="48.2157, 22.0778" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="XL Bútor - Egyedi bútor gyártás" />
      <meta property="og:site_name" content="XL Bútor" />
      <meta property="og:locale" content="hu_HU" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Mobile & PWA */}
      <meta name="theme-color" content="#1E1E1E" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="XL Bútor" />
      <meta name="application-name" content="XL Bútor" />
      
      {/* Preconnect to external resources */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* DNS Prefetch */}
      <link rel="dns-prefetch" href="https://bdtiuojmntcptttfprgt.supabase.co" />

      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
}
